const Calendar = () => {
  return (
    <section className="section">
      <div className="container">
        <div className="section-head">
          <span className="eyebrow">Availability</span>
          <h2>Check the calendar.</h2>
          <p>See which dates are open and plan your retreat. To book, reach out via the contact page.</p>
        </div>

        <div className="calendar-card">
          <div className="calendar-frame">
            <iframe
              title="Upward Bound availability calendar"
              src="https://www.google.com/calendar/embed?src=pddl6jkdms0d1ag05uc3n51n10%40group.calendar.google.com&amp;ctz=America/New_York"
              scrolling="no"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Calendar;
